import React from 'react'
import PropTypes from 'prop-types'
import { ListingV2 } from 'Pages'

import { _LinkWrapper } from './styles'


const LinkWrapper = ({
  children,
  onHover,
  onMouseLeave,
  handleUnlockedClick,
  futureOpenHouses,
  openNewTab,
  listing,
  isArchived,
  noLinkTag = false,
}) => (
  <_LinkWrapper
    onMouseEnter={() => {
      ListingV2.preload()
      if(onHover) onHover()
    }}
    onMouseLeave={onMouseLeave}
    onFocus={() => ListingV2.preload()}
    onClick={(e) => handleUnlockedClick(e, futureOpenHouses)}
    openNewTab={openNewTab}
    to={`/${listing?.url}`}
    alt={listing?.title}
    lookupLinkData={{
      component: 'Listing',
      id: listing?.id,
    }}
    mobileModalChildren={
      // eslint-disable-next-line react/no-unstable-nested-components
      ({ closeModalPage }) => (
        <ListingV2
          listingId={listing?.id}
          modalListingData={listing}
          closeModalPage={closeModalPage}
          isArchived={isArchived}
        />
      )
    }
    mobileModalKey={`listingModal-${listing?.id}`}
    noLinkTag={noLinkTag}
  >
    {children}
  </_LinkWrapper>
)


LinkWrapper.propTypes = {
  listing: PropTypes.shape({
    mls_number: PropTypes.string,
    featured: PropTypes.bool,
    id: PropTypes.number,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  children: PropTypes.node,
  onHover: PropTypes.func,
  onMouseLeave: PropTypes.func,
  handleUnlockedClick: PropTypes.func,
  futureOpenHouses: PropTypes.arrayOf(PropTypes.shape({})),
  openNewTab: PropTypes.bool,
  isArchived: PropTypes.bool,
  noLinkTag: PropTypes.bool,
}

export default LinkWrapper
